<template>
  <div class="banner-pan banner-pan-pc posRe" ref="bannerPan">
    <img class="logo animated bounceIn" :src="logo"/>
    <a v-if="seePanUrl" :href="seePanUrl" class="icon-img icon-see-pan" target="_pan"></a>
    <div class="iframe iframe-pan" :class="[panUrl||logo?'':'no-iframe-pan']" id="iframe-pan">
      <!--<iframe id="frameA" ref="iframeA" class=""  name="frameA"></iframe>-->
      <iframe id="frameA" ref="iframeA" class="" :src="panUrl" name="frameA"></iframe>
    </div>
    <div class="swiper-container container-pan">
      <div class="swiper-wrapper">
        <template v-if="paoThumbData&&paoThumbData.length&&paoThumbData.length>0">
          <template v-for="(list,index) in paoThumbData">
            <div class="swiper-slide" :class="[(paoThumbIndex==index?'active':'')]" :key="'pan'+index">
              <div class="pan-name" :class="[list.pano_id?'':'no-list-data']" @click.stop="panClick(index,list.pano_id,true)">
                <div class="pan-text"><span>{{list.title||'重点推荐'}}</span></div>
                <div class="pan-icon"></div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <div class="pan-address animated fadeInUp">
      <div class="swiper-container container-address" ref="panBannerAddress">
        <div class="swiper-wrapper">
          <template v-if="addressList&&addressList.length">
            <template v-for="(item, i) in addressList">
              <div  class="swiper-slide" :class="['slide-address'+i,item.state?'':'no-click']" :key="'addressList'+i">
                <div @click="pageCityTo(item)">{{item.name}}</div>
              </div>
            </template>
            <template v-if="addressMore.data&&addressMore.data.length">
              <div class="swiper-slide" :key="'addressLista'">
                <el-popover
                  placement="bottom-end"
                  :width="(client>=2)?client==2?400:300:800"
                  popper-class="address-more-lists"
                  trigger="click"
                >
                  <div class="el-popover-lists" :class="[(client>=2?client==2?'el-popover-lists2':'el-popover-lists2':'')]">
                    <template v-for="(item, i) in addressMore.data">
                      <template v-if="item&&item.length">
                        <div class="clearFloat" :key="'addressList'+i">
                          <template v-for="(child,childIndex) in item">
                            <div :class="[child.state?'popover-lists-tab':'popover-lists-no-tab']" @click="pageCityTo(child)">
                              <span class="oneRow">
                                  {{child.name}}
                                </span>
                            </div>
                          </template>
                        </div>
                      </template>
                    </template>
                  </div>
                  <template><div slot="reference" class="pan-tab-more" :class="[addressMore.stateNum?'':'']">{{addressMore.stateNum?'更多':'建设中'}}</div></template>
                  <!--<template>-->
                    <!--<div :class="[addressMore.stateNum?'':'']">{{addressMore.stateNum?'更多':'建设中'}}</div>-->
                  <!--</template>-->
                </el-popover>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pan',
  props:['client'],
  data () {
    return {
      logo: '',
      lists: [],
      addressList: [],
      addressMore:{},
      panUrl: '',
      activeIndex: 0,
      loaded: false,
      paoThumbData: [],
      paoThumbIndex: 0,
      iframeWin: {},
      seePanUrl: '',
      swiperPanObj: '',
      panActiveIndex:0,
      timer:null,
      addressHoverWid:''
    }
  },
  created () {
  },
  mounted () {
    let that = this;
    that.httpData();
    let i=that.$root.panIndex;
    that.panActiveIndex=i;
    window.addEventListener('message', function (event) {
      let data = JSON.parse(JSON.stringify(event.data));
      if (data.msg === 'success') {
        if(data.isList){
          let len=data.data && data.data.length?data.data.length:0;
          if(len){
            that.paoThumbData = data.data;
            that.swiperPan(i)
          }
        }
        if (data.activeIndex >= 0) {
          that.paoThumbIndex = data.activeIndex;
          that.seePanUrl = that.paoThumbData[data.activeIndex].url
        }
      }
    });
    that.iframeWin = that.$refs.iframeA.contentWindow
  },
  methods: {
    panClick: function (index,pano_id,bool) {
      let that=this;
      if(pano_id){
        clearInterval(that.timer);
        that.swiperPanObj.slideTo(index);
        that.iframeWin.postMessage({
          cmd: 'activeIndex',
          activeIndex: index
        }, '*');
        that.panActiveIndex=index;
      }
    },
    httpData: function () {
      let _that = this;
      _that.httpAjax.getAjax('CityWebService.asmX/GetSiteInfoByCity', {cityId: 0}).then(function (res) {
        if (res.code === 1) {
          _that.lists = res.data;
          _that.logo = _that.lists[_that.activeIndex].logo;
          _that.panUrl = _that.lists[_that.activeIndex].panoUrl;
          _that.panActiveIndex=_that.activeIndex;
          _that.publicJs.panMousewheel(function (val) {
            if(val){
              clearInterval(_that.timer);
            }else {
              _that.timeSwiper(_that.panActiveIndex)
            }
          });

        }
      }, function (err) {
        console.log(err)
      });
      this.publicJs.addressGetData(function (res) {
        if (res.code === 1) {
          let banWid=_that.$refs.bannerPan.clientWidth;
          let marRight=90;
          if(banWid>1500){
            marRight=90;
          }else if(banWid<=1500&&banWid>1300){
            marRight=60;
          }else if(banWid<=1300&&banWid>1200){
            marRight=40;
          }else if(banWid<=1200&&banWid>850){
            marRight=80;
          }else{
            marRight=60;
          }
          _that.addressHoverWid=_that.$refs.panBannerAddress.clientWidth;
          let n=(Math.round( _that.addressHoverWid/(54+marRight))-1),k=0;

          for(var i=0;i<res.data.length;i++){
            if(res.data[i].state==1){
              res.data[i].childIndex=i;
              k++;
            }
          }
          let w=(k>n?n:k);
//          let w=n;
          let m=((_that.client>=2)?_that.client==2?3:3:5);
          _that.addressList = (res.data).slice(0,w);
          _that.addressMore.data=_that.publicJs.newList((res.data).slice(w),m+1);
          _that.addressMore.stateNum=(k-n?true:false);

        }
      })
    },
    pageCityTo: function (city) {
      if(!city.state){
        return false;
      }
      const c = this.$router.resolve({
        path: '/pageCity',
        query: {
          key: this.publicJs.encode(JSON.stringify({
            cityId: city.cityId,
            typeId: 0,
          })),
          '_': new Date().getTime()
        }
      });
      window.open(c.href, '_pageCity' + city.cityId)
    },
    moreCity:function () {

    },
    swiperPan: function (n) {
      let _that = this,
        time=null;
      setTimeout(function () {
        // eslint-disable-next-line
        _that.swiperPanObj = new Swiper('.container-pan', {
          direction: 'vertical',
          slidesPerView: 5,
          spaceBetween: 10,
          watchOverflow: true,
          initialSlide:n,
//          autoplay: true,
          on:{
            init:function(){
              if(n>0){
                _that.iframeWin.postMessage({
                  cmd: 'activeIndex',
                  activeIndex: n
                }, '*');
                _that.timeSwiper(n);
              }else {
                _that.timeSwiper(this.activeIndex)
              }
            },
            slideChangeTransitionStart:function(){
              console.log('slideChangeTransitionStart')
            },
          }
        });

      }, 50);
    },
    timeSwiper:function (n) {
      let _that=this,
        list=_that.paoThumbData,
        len=list&&list.length?list.length:0;

      if(len<=1){
       return false;
      }

      _that.timer=setInterval(function () {
        let i=((n>=(len-1))?0:n+1);
        if(list[i].pano_id){
          _that.swiperPanObj.slideTo(i);
          _that.iframeWin.postMessage({
            cmd: 'activeIndex',
            activeIndex: i
          }, '*');
        }
        _that.panActiveIndex=i;
        clearInterval(_that.timer);

      },15000)
    },
    swiperAddress: function () {
      setTimeout(function () {
        // eslint-disable-next-line
        let containerAddress = new Swiper('.container-address', {
          slidesPerView: 'auto',
          spaceBetween: 90,
          watchOverflow: true,
          centerInsufficientSlides: true,
          breakpoints: {
            1500: {
              spaceBetween: 60
            },
            1300: {
              spaceBetween: 40
            },
            1200: {
              spaceBetween: 80
            },
            850: {
              spaceBetween: 60
            },
//            900: {
//              spaceBetween: 25
//            },
//            800: {
//              spaceBetween: 30
//            },
//            750: {
//              spaceBetween: 20
//            }
          },
          on: {
            init: function () {
            }
          }
        })
      }, 50)
    }
  },
  beforeDestroy(){
    this.$root.panIndex=this.panActiveIndex;
    if(this.timer){
      clearInterval(this.timer)
    }
  },
  watch: {
    lists: function (a, b) {
      // this.swiperPan()
    },
    addressList: function (a, b) {
      this.swiperAddress()
    },
    panActiveIndex:function (newVal,b) {
//      console.log('newVal,b-------')
//      console.log('newVal---:'+newVal,'b---:'+b)
      if(newVal!=b){
        this.timeSwiper(newVal)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner-pan{
    height: 700px;
    background-color:#e7f6ff;
    overflow: hidden;
  }
  .logo{
    position: absolute;
    width: 512px;
    left: 50%;
    margin-left: -256px;
    z-index: 2;
    top:154px;
  }
  .pan-address{
    position: absolute;
    left: 10%;
    right: 10%;
    bottom: 0;
    z-index: 2;
    background: linear-gradient(left, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 40%, rgba(0,0,0,0.4) 50%,rgba(0,0,0,0.4) 70%, rgba(0,0,0,0) 100%);
    background: -ms-linear-gradient(left, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 40%, rgba(0,0,0,0.4) 50%,rgba(0,0,0,0.4) 70%, rgba(0,0,0,0) 100%);
    background: -webkit-linear-gradient(left, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 40%, rgba(0,0,0,0.4) 50%,rgba(0,0,0,0.4) 70%, rgba(0,0,0,0) 100%);
    background: -moz-linear-gradient(left, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 40%, rgba(0,0,0,0.4) 50%,rgba(0,0,0,0.4) 70%, rgba(0,0,0,0) 100%);
    padding: 9px 0;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -khtml-user-select: none;
    user-select: none;
  }
  .pan-address .swiper-container{
    width: 70%;
    margin: 0 auto;
  }
  .pan-address .swiper-slide{
    width: auto;
    font-size: 18px;
    color: #FFFFFF;
    text-align: center;
  }
  .pan-address .swiper-slide:hover{
    color: #f6bc32;
    font-weight: bold;
    -webkit-transition: color 0.5s ease-in-out;
    -moz-transition: color 0.5s ease-in-out;
    -ms-transition: color 0.5s ease-in-out;
    -o-transition: color 0.5s ease-in-out;
    transition: color 0.5s ease-in-out;
  }
  .pan-address .no-click,
  .pan-address .no-click:hover{
    color: #c2c2c2;
  }
  .pan-address .no-click>div{
    cursor: no-drop;
  }

  .el-popover-lists>div{
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 0.5rem;
  }
  .el-popover-lists>div>div{
    float: left;
    font-size: 1rem;
    padding:1rem 0;
    width: 16.666%;
    text-align: center;
  }
  .popover-lists-tab{
    color: #585858;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
    cursor: pointer;
  }
  .popover-lists-tab:hover{
    color: #298fe4;
    font-weight: bold;
  }
  .popover-lists-no-tab{
    color: #aeaeae;
    cursor: no-drop;
  }

  .el-popover-lists2.el-popover-lists>div>div{
    width: 25%;
    font-size: 0.875rem;
    padding: 0.5rem 0;
  }
  .pan-tab-more{
    padding-right: 1.5rem;
    background-repeat: no-repeat;
    background-position: center right;
    background-size: 1.4rem;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/pan.vue